export default "__VITE_ASSET__DB83oZ33__"